import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';

const useGoogleTracking = () => {
	const location = useLocation();
	const [initialized, setInitialized] = useState<boolean>(false);
	const [previousRoute, setPreviousRoute] = useState<string>('');

	useEffect(() => {
		if (process.env.REACT_APP_GTM_ID && process.env.NODE_ENV === 'production') {
			const tagManagerArgs = {
				gtmId: process.env.REACT_APP_GTM_ID,
			};
			TagManager.initialize(tagManagerArgs);
			setInitialized(true);
		}
	}, []);

	useEffect(() => {
		if (initialized) {
			if (location.pathname !== '/' && previousRoute !== location.pathname) {
				setPreviousRoute(location.pathname);
				TagManager.dataLayer({
					dataLayer: {
						event: 'pageview',
						page: {
							url: location.pathname + location.search,
						},
					},
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialized, location]);
};

export default useGoogleTracking;
